import React from "react";
import { Area } from '@ant-design/charts';

export const Graph2 = () => {
  const data = [
    { year: '2022', value: 50, type: 'Выполнено' },
    { year: '2022', value: 80, type: 'Не требуется' },
    { year: '2022', value: 60, type: 'Не выполнено' },
    { year: '2023', value: 65, type: 'Выполнено' },
    { year: '2023', value: 70, type: 'Не требуется' },
    { year: '2023', value: 75, type: 'Не выполнено' },
    { year: '2024', value: 60, type: 'Выполнено' },
    { year: '2024', value: 55, type: 'Не требуется' },
    { year: '2024', value: 100, type: 'Не выполнено' },
  ];
  const config = {
    data,
    xField: 'year',
    yField: 'value',
    seriesField: 'type',
    smooth: true,
    color: ['#3DAA1B', '#FFB200', '#5B8FF9'],
    areaStyle: (datum: any) => {
      if (datum.type === 'Выполнено') return { fill: 'l(270) 0:#3DAA1B 1:#E6F7E6', fillOpacity: 0.5 };
      if (datum.type === 'Не требуется') return { fill: 'l(270) 0:#FFB200 1:#FFF7E6', fillOpacity: 0.5 };
      if (datum.type === 'Не выполнено') return { fill: 'l(270) 0:#5B8FF9 1:#E6F0FF', fillOpacity: 0.5 };
      return {};
    },
    line: { style: { lineWidth: 4 } },
    point: { size: 6, shape: 'circle', style: { fill: '#fff', stroke: '#3DAA1B', lineWidth: 2 } },
    legend: {
      position: 'bottom' as const,
      itemName: {
        style: (item: any) => {
          if (item.name === 'Выполнено') return { fill: '#3DAA1B', fontWeight: 700, fontSize: 16 };
          if (item.name === 'Не требуется') return { fill: '#FFB200', fontWeight: 700, fontSize: 16 };
          if (item.name === 'Не выполнено') return { fill: '#5B8FF9', fontWeight: 700, fontSize: 16 };
          return {};
        }
      }
    },
    xAxis: {
      label: { style: { fontSize: 16, fontWeight: 500 } },
      title: null,
    },
    yAxis: {
      min: 20,
      max: 110,
      label: { style: { fontSize: 16, fontWeight: 500 } },
      title: null,
    },
    tooltip: { showMarkers: false },
    title: {
      visible: true,
      text: 'Динамика задач животноводство / растениеводство',
      style: { fontSize: 24, fontWeight: 700, marginBottom: 24 },
    },
    height: 400,
    padding: [40, 40, 60, 40],
  };

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 24}}>
      <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Динамика задач животноводство / растениеводство</div>
      <Area {...config} />
    </div>
  );
};   